import Create from "../components/posts/create/Create";
import Left from "../components/posts/left/Left";
import CreatedPosts from "../components/posts/posts/CreatedPosts";

const Posts = () => {
  return (
    <div className="min-h-screen bg-orange-50">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-4 p-10">
        {/* Left Profile Section - Stacks on mobile, 1 column on desktop */}
        <Left />
        {/* Posts Section - Stacks on mobile, 3 columns on desktop */}
        <div className="space-y-4 md:col-span-3">
          {/* Create Post Box Sketch */}
          <Create />

          {/* Divider */}
          <div className="flex items-center gap-2">
            <div className="h-[1px] flex-1 bg-orange-200"></div>
            <div className="h-3 w-16 rounded bg-orange-100"></div>
          </div>

          <CreatedPosts />
        </div>
      </div>
    </div>
  );
};

export default Posts;
